import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _ENTITY_REFERENCE_TYP, _ENTITY_REFERENCE_TYP2;

import { PARTS, SERVICES } from '../appServices';
import PART_ENTITY_TYPES from './partEntitytypes';
var FULFILMENT = 'FULFILMENT';
var SALES_ORDER = 'SALES_ORDER';
var CUSTOMER = 'CUSTOMER';
var PNA = 'PNA';
var STOCK = 'STOCK';
var REPAIR_ORDER = 'RO';
var PURCHASE_ORDER = 'PURCHASE_ORDER';
var PHYSICAL_INVENTORY = 'PHYSICAL_INVENTORY';
var PART_INVENTORY = 'PART_INVENTORY';
var SALES_ORDER_INVOICE = 'SALES_ORDER_INVOICE';
var PARTS_RECEIVING = 'PARTS_RECEIVING';
var CREDIT_MEMO = 'CREDIT_MEMO';
var RO_SALES = 'RO_SALES';
var REPAIR_ORDER_EXPRESS = 'RO_SALES_EXPRESS';
export var ENTITY_REFERENCE_TYPES = {
  FULFILMENT: FULFILMENT,
  SALES_ORDER: SALES_ORDER,
  CUSTOMER: CUSTOMER,
  PNA: PNA,
  STOCK: STOCK,
  REPAIR_ORDER: REPAIR_ORDER,
  PURCHASE_ORDER: PURCHASE_ORDER,
  PHYSICAL_INVENTORY: PHYSICAL_INVENTORY,
  PART_INVENTORY: PART_INVENTORY,
  SALES_ORDER_INVOICE: SALES_ORDER_INVOICE,
  PARTS_RECEIVING: PARTS_RECEIVING,
  CREDIT_MEMO: CREDIT_MEMO,
  RO_SALES: RO_SALES,
  REPAIR_ORDER_EXPRESS: REPAIR_ORDER_EXPRESS
};
export var ENTITY_REFERENCE_TYPES_VS_APP_MODULE = (_ENTITY_REFERENCE_TYP = {}, _defineProperty(_ENTITY_REFERENCE_TYP, ENTITY_REFERENCE_TYPES.REPAIR_ORDER, {
  service: SERVICES,
  module: 'REPAIR_ORDER' // TODO change this once service team updates route factory

}), _defineProperty(_ENTITY_REFERENCE_TYP, ENTITY_REFERENCE_TYPES.FULFILMENT, {
  service: PARTS,
  module: PART_ENTITY_TYPES.FULFILMENT
}), _defineProperty(_ENTITY_REFERENCE_TYP, ENTITY_REFERENCE_TYPES.SALES_ORDER, {
  service: PARTS,
  module: PART_ENTITY_TYPES.SALES_ORDER
}), _defineProperty(_ENTITY_REFERENCE_TYP, ENTITY_REFERENCE_TYPES.SALES_ORDER_INVOICE, {
  service: PARTS,
  module: PART_ENTITY_TYPES.SALES_ORDER
}), _defineProperty(_ENTITY_REFERENCE_TYP, ENTITY_REFERENCE_TYPES.CREDIT_MEMO, {
  service: PARTS,
  module: PART_ENTITY_TYPES.SALES_ORDER
}), _defineProperty(_ENTITY_REFERENCE_TYP, ENTITY_REFERENCE_TYPES.CUSTOMER, {
  service: PARTS,
  module: PART_ENTITY_TYPES.SPECIAL_ORDER_REQUEST
}), _defineProperty(_ENTITY_REFERENCE_TYP, ENTITY_REFERENCE_TYPES.PURCHASE_ORDER, {
  service: PARTS,
  module: PART_ENTITY_TYPES.PURCHASE_ORDER
}), _defineProperty(_ENTITY_REFERENCE_TYP, ENTITY_REFERENCE_TYPES.PHYSICAL_INVENTORY, {
  service: PARTS,
  module: PART_ENTITY_TYPES.PHYSICAL_INVENTORY
}), _defineProperty(_ENTITY_REFERENCE_TYP, ENTITY_REFERENCE_TYPES.PART_INVENTORY, {
  service: PARTS,
  module: PART_ENTITY_TYPES.PART_INVENTORY
}), _defineProperty(_ENTITY_REFERENCE_TYP, ENTITY_REFERENCE_TYPES.PARTS_RECEIVING, {
  service: PARTS,
  module: PART_ENTITY_TYPES.PARTS_RECEIVING
}), _ENTITY_REFERENCE_TYP);
export var ENTITY_REFERENCE_TYPES_TO_LABEL = (_ENTITY_REFERENCE_TYP2 = {}, _defineProperty(_ENTITY_REFERENCE_TYP2, ENTITY_REFERENCE_TYPES.REPAIR_ORDER, __('Repair Order')), _defineProperty(_ENTITY_REFERENCE_TYP2, ENTITY_REFERENCE_TYPES.FULFILMENT, __('Repair Order')), _defineProperty(_ENTITY_REFERENCE_TYP2, ENTITY_REFERENCE_TYPES.SALES_ORDER, __('Sales Order')), _defineProperty(_ENTITY_REFERENCE_TYP2, ENTITY_REFERENCE_TYPES.SALES_ORDER_INVOICE, __('Sales Order')), _defineProperty(_ENTITY_REFERENCE_TYP2, ENTITY_REFERENCE_TYPES.CUSTOMER, __('Customer SOR')), _defineProperty(_ENTITY_REFERENCE_TYP2, ENTITY_REFERENCE_TYPES.PURCHASE_ORDER, __('Purchase Order')), _defineProperty(_ENTITY_REFERENCE_TYP2, ENTITY_REFERENCE_TYPES.PHYSICAL_INVENTORY, __('Physical Inventory')), _defineProperty(_ENTITY_REFERENCE_TYP2, ENTITY_REFERENCE_TYPES.CREDIT_MEMO, __('Credit Memo')), _defineProperty(_ENTITY_REFERENCE_TYP2, ENTITY_REFERENCE_TYPES.REPAIR_ORDER_EXPRESS, __('Repair Order - Express')), _defineProperty(_ENTITY_REFERENCE_TYP2, "OTHERS", __('Others')), _ENTITY_REFERENCE_TYP2);
export var SERVICE_MODE = {
  REGULAR: 'REGULAR',
  EXPRESS: 'EXPRESS'
};